import { BaseRequest } from '@/network/requests/BaseRequest'
import { jt_tech } from '@/interfaces/jt_tech'

export const jtTechRequest = BaseRequest.build<jt_tech>('jt_tech')
